import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import heroImage from "../assets/new-data-services-Ar-iTL4QKl4-unsplash.jpg";
import { Link } from "react-router";

export const HomePage: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <div
        className="w-full"
        style={{ height: "600px", position: "relative", overflow: "hidden" }}
      >
        <img
          src={heroImage}
          alt="Hero Background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            filter: "blur(5px)",
            transform: "scale(1.1)",
          }}
        />

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "1rem",
          }}
        >
          <h1
            style={{ color: "white", fontSize: "3rem", marginBottom: "1rem" }}
          >
            We Are Logic Innova
          </h1>
          <p
            style={{
              color: "white",
              fontSize: "1.5rem",
              marginBottom: "2rem",
              maxWidth: "800px",
            }}
          >
            Creating innovative solutions to modernize business processes with
            strategic use of technology
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <Link to="/contact">
              <Button
                label="Get Started"
                icon="pi pi-arrow-right"
                iconPos="right"
                style={{
                  fontSize: "1.1rem",
                  padding: "0.75rem 2rem",
                  gap: "0.5rem",
                }}
              />
            </Link>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="container mx-auto px-8 py-24">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-bold mb-6 pt-4 text-gray-900 dark:text-white">
            Transform Your Business with Technology
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed pt-2">
            We specialize in modernizing business processes through strategic
            technology implementation, helping organizations achieve efficiency
            and growth.
          </p>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gray-50 dark:bg-gray-900 py-24 pb-40">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16 pt-8 pb-6 text-gray-900 dark:text-white">
            Why Choose Logic Innova?
          </h2>
          <div className="flex flex-wrap justify-center gap-8 max-w-7xl mx-auto">
            <Card
              className="shadow-lg hover:shadow-2xl transition-all duration-300 border-0 hover:-translate-y-2 flex-shrink-0"
              style={{ width: "calc(50% - 1rem)", minHeight: "320px" }}
            >
              <div className="text-center p-4 h-full flex flex-col">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 mb-6 shadow-lg mx-auto">
                  <i className="pi pi-users text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                  Expert Team
                </h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed flex-grow">
                  Our experienced professionals bring deep technical expertise
                  and industry knowledge.
                </p>
              </div>
            </Card>

            <Card
              className="shadow-lg hover:shadow-2xl transition-all duration-300 border-0 hover:-translate-y-2 flex-shrink-0"
              style={{ width: "calc(50% - 1rem)", minHeight: "320px" }}
            >
              <div className="text-center p-4 h-full flex flex-col">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-cyan-600 mb-6 shadow-lg mx-auto">
                  <i className="pi pi-check-circle text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                  Proven Results
                </h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed flex-grow">
                  Track record of successful implementations that deliver
                  measurable business value.
                </p>
              </div>
            </Card>

            <Card
              className="shadow-lg hover:shadow-2xl transition-all duration-300 border-0 hover:-translate-y-2 flex-shrink-0"
              style={{ width: "calc(50% - 1rem)", minHeight: "320px" }}
            >
              <div className="text-center p-4 h-full flex flex-col">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-pink-600 mb-6 shadow-lg mx-auto">
                  <i className="pi pi-sparkles text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                  Modern Technology
                </h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed flex-grow">
                  Leveraging cutting-edge tools and frameworks to build modern
                  solutions.
                </p>
              </div>
            </Card>

            <Card
              className="shadow-lg hover:shadow-2xl transition-all duration-300 border-0 hover:-translate-y-2 flex-shrink-0"
              style={{ width: "calc(50% - 1rem)", minHeight: "320px" }}
            >
              <div className="text-center p-4 h-full flex flex-col">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-orange-500 to-red-600 mb-6 shadow-lg mx-auto">
                  <i className="pi pi-heart text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                  Client-Focused
                </h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed flex-grow">
                  Your success is our priority. We work closely with your
                  stakeholders every step of the way.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>

      <br />
      <br />

      {/* CTA Section */}
      <div className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 dark:from-blue-700 dark:via-blue-800 dark:to-indigo-900 mt-16 pt-40 pb-24 overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full bg-white blur-3xl"></div>
          <div className="absolute top-1/2 left-1/3 w-24 h-24 rounded-full bg-white blur-2xl"></div>
        </div>

        <div className="container mx-auto px-6 text-center relative z-10">
          {/* Icon Feature Row */}
          <div className="flex justify-center gap-8 mb-8 flex-wrap">
            <div className="flex items-center gap-2 text-white/90">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                <i className="pi pi-check text-white text-lg"></i>
              </div>
              <span className="text-sm font-medium">Free Consultation</span>
            </div>
            <div className="flex items-center gap-2 text-white/90">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                <i className="pi pi-bolt text-white text-lg"></i>
              </div>
              <span className="text-sm font-medium">Fast Response</span>
            </div>
            <div className="flex items-center gap-2 text-white/90">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                <i className="pi pi-shield text-white text-lg"></i>
              </div>
              <span className="text-sm font-medium">Proven Track Record</span>
            </div>
          </div>

          <h2 className="text-5xl font-bold text-white mb-6">
            Ready to Transform Your Business Processes?
          </h2>
          <p className="text-xl text-white mb-10 max-w-2xl mx-auto leading-relaxed">
            Let's discuss how we can help you achieve your technology goals and
            drive meaningful results.
          </p>
          <div className="flex gap-5 justify-center flex-wrap">
            <Link to="/contact">
              <Button
                label="Schedule a Consultation"
                icon="pi pi-calendar"
                iconPos="right"
                size="large"
                className="shadow-2xl hover:shadow-3xl transition-all hover:scale-105"
                style={{
                  gap: "0.5rem",
                  padding: "1rem 2rem",
                  fontSize: "1.1rem",
                }}
              />
            </Link>
            <Link to="/about">
              <Button
                label="Our Processes"
                icon="pi pi-arrow-right"
                iconPos="right"
                outlined
                size="large"
                className="shadow-xl hover:shadow-2xl transition-all hover:scale-105 hover:bg-white/10"
                style={{
                  color: "white",
                  borderColor: "white",
                  borderWidth: "2px",
                  gap: "0.5rem",
                  padding: "1rem 2rem",
                  fontSize: "1.1rem",
                }}
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
